import AdminHeader from "./Components/AdminHeader";
import AdminSidebar from "./Components/AdminSidebar";

function Dashboard() {
    return (
        <div className="admin-page">

            <AdminHeader />

            <div className="admin-body">

                <AdminSidebar />

                <main className="admin-content">

                    <div className="admin-welcome-card">

                        <h1>Welcome to the Admin Dashboard</h1>

                        <p>
                            This is where all content updates, user management,
                            and system configuration are handled.
                        </p>

                        <p>
                            Please use the sidebar to navigate through the
                            available sections.
                        </p>

                        <div className="admin-divider" />

                        <p className="admin-contact">
                            If you experience any issues, please contact:
                            <strong>kyle@optimalonline.co.za</strong>
                        </p>

                    </div>

                </main>

            </div>

        </div>
    );
}

export default Dashboard;
